import { ReactNode } from 'react';

interface Feature {
    title: string;
    body: ReactNode;
}

const FEATURES: Feature[] = [
    {
        title: 'Model Portfolios',
        body: 'Apply a target allocation using your own custom-built models, Claro-managed strategies (including Personalized Indexing), or models from external asset managers. You can build a model from scratch, apply an existing one, or simply set a client’s current holdings as the starting target.',
    },
    {
        title: 'Automated Rebalancing',
        body: 'Enrolled accounts are rebalanced regularly to maintain target weights.',
    },
    {
        title: 'Tax-Loss Harvesting',
        body: 'Where appropriate, Portfolio Boost monitors for opportunities to realize losses and automatically executes harvesting trades, replacing sold positions with designated substitutes to maintain market exposure.',
    },
    {
        title: 'Tax Budgets',
        body: 'Set an annual cap on net capital gains impact for an account. The engine respects that constraint when making trading decisions throughout the calendar year.',
    },
    {
        title: 'Liquidity Automation',
        body: 'The Portfolio Engine is aware of upcoming cash needs — including planned withdrawals that you may enter and advisory fees — and proactively raises cash ahead of those events as part of the rebalance process.',
    },
    {
        title: 'CashEQ',
        body: 'Idle cash not reserved for upcoming needs is automatically swept into a 0–3 month Treasury Bill ETF, SGOV, to improve yield between rebalance cycles.',
    },
    {
        title: 'Asset Location',
        body: 'For multi-account portfolios, the engine can locate specific asset classes into preferred tax-advantaged account types — for example, preferring tax-inefficient assets in IRAs and tax-efficient assets in taxable accounts.',
    },
];

const PRICING_OPTIONS: Feature[] = [
    {
        title: 'Whole-book pricing',
        body: 'Opt your entire book into 3 bps of total AUM and enroll any account at any time with no per-account fee.',
    },
    {
        title: 'Per-account pricing',
        body: '6 bps assessed at the time of enrollment, which the advisor can absorb or pass through to the client.',
    },
];

export const PortfolioBoostLearnMore = () => (
    <div className="border-gold-200/60 bg-gold-50/20 flex flex-col gap-5 rounded-lg border p-5">
        {FEATURES.map((feature) => (
            <div key={feature.title}>
                <h4 className="text-cocoa-1000 text-sm font-semibold">{feature.title}</h4>
                <p className="text-cocoa-600 mt-1 text-sm leading-relaxed">{feature.body}</p>
            </div>
        ))}

        <div>
            <h4 className="text-cocoa-1000 text-sm font-semibold">Pricing</h4>
            <p className="text-cocoa-600 mt-1 text-sm leading-relaxed">
                Portfolio Boost fees are billed monthly in arrears. Advisors choose one of two options at enrollment:
            </p>
            <ul className="text-cocoa-600 mt-3 list-disc space-y-2 pl-5 text-sm leading-relaxed">
                {PRICING_OPTIONS.map((option) => (
                    <li key={option.title}>
                        <span className="text-cocoa-1000 font-medium">{option.title}:</span> {option.body}
                    </li>
                ))}
            </ul>
        </div>
    </div>
);
